import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { RelacaoGenerica } from 'src/app/models/bas/relacao-generica/relacao-generica';
import { AbstractIdbaRequestModel } from 'src/app/shared/models/abstract-idba-request-model';
import { AbstractIdbaService } from 'src/app/shared/utils/abstract-idba-service.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RelacaoGenericaService extends AbstractIdbaService {

  override model: RelacaoGenerica;
  private relacoesGenericas: RelacaoGenerica[] = [];

  constructor(http: HttpClient) {
    super(http, new RelacaoGenerica());
    this.programName = "cad/genericos/relgenerico.p";
    this.listProcedure = "pi-listar-rel-gener-assunto"
  }

  listarRelacoes() {
    const request = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-listar";
    request.parameters = {};
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }

  listarRelacaoGenericaPorAssunto(rowid) {
    const request = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-listar-rel-gener-assunto";
    request.parameters = { rowid };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }

  listarRelacaoGenericaPorUsuario() {
    const request = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-retorna-relgener-usuario";
    request.parameters = {};
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }

  salvaRelacao(registro) {
    const request = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-incluir";
    request.parameters = { registro };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }

  alteraRelacao(registro) {
    const request = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-alterar";
    request.parameters = { registro };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }

  excluiRelacao(rowid) {
    const request = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-excluir-assunto";
    request.parameters = { rowid };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }

  excluirAssuntoRelacao(rowid) {
    const request = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-excluir";
    request.parameters = { rowid };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }

  retornaRelacaoGenerica(param) {
    const request = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-retorna-rel-gener";
    request.parameters = param;
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }

  buscarRelacaoGenericaPorAssunto(assunto) {
    const request = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-buscar-rel-gener-assunto";
    request.parameters = { assunto };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }

  async getRelacaoGenericaBySubjectList(assuntos: string[]) {
    this.relacoesGenericas = [];
    const request = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-buscar-rel-gener-assunto-lista";
    request.parameters = { assuntos };

    const response$ = this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
    const response = await lastValueFrom(response$);
    if (response.body && response.body.retorno && response.body.retorno.registro) {
      this.relacoesGenericas = response.body.retorno.registro.map(item => new RelacaoGenerica(item));
    } 

  }

  getByCodigo(assunto: string, codigo: string): string | undefined {
    const relacao = this.relacoesGenericas.find(rel => rel.assunto === assunto && rel.codigo === codigo);
    return relacao ? relacao.valor : undefined;
  }

}
